module.exports = __webpack_public_path__ + "img/gao5.43c2df33.png";